import React from 'react'
import FeedbackDashboard from './Feedback/FeedbackDashboard'

export default function Feedback() {
  return (
    <div><FeedbackDashboard /></div>
  )
}
